<template>
  <v-container>
    <EbookInstructor
      @goto="goto"
      :currentReport="currentReport"
      v-if="show == 'instructor'"
    ></EbookInstructor>
    <EbookPeriod
      @goto="goto"
      :currentReport="currentReport"
      v-if="show == 'period'"
    ></EbookPeriod>
    <EbookWorkplace
      @goto="goto"
      :currentReport="currentReport"
      v-if="show == 'workplace'"
    ></EbookWorkplace>
    <EbookElement
      @goto="goto"
      :currentReport="currentReport"
      :element="editElement"
      v-if="show == 'element'"
    ></EbookElement>
    <EbookReview
      @goto="goto"
      :currentReport="currentReport"
      v-if="show == 'review'"
    ></EbookReview>
    <!-- <EbookAddElement @goto="goto" v-if="show=='addElement'"></EbookAddElement>     -->
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import API from "@/services/api.js";
// new steps

import EbookInstructor from "@/components/Ebook/Apprentice/EbookInstructor";
import EbookPeriod from "@/components/Ebook/Apprentice/EbookPeriod";
import EbookWorkplace from "@/components/Ebook/Apprentice/EbookWorkplace";
import EbookElement from "@/components/Ebook/Apprentice/EbookElement";
import EbookReview from "@/components/Ebook/Apprentice/EbookReview";

// @group Ebook
// Styled ReportStart component
export default {
  name: "ReportStart",

  components: {
    EbookInstructor,
    EbookPeriod,
    EbookWorkplace,
    EbookElement,
    EbookReview,
  },

  data: () => ({
    show: "",
    currentReport: {},
    editElement: {},
  }),
  methods: {
    goto(params) {
      this.show = params.goto;
      this.currentReport = params.report;
      if (params.item) {
        this.editElement = params.item;
      } else {
        this.editElement = {};
      }
    },
    init() {
      if (!(this.$route.params.id || Number(this.$route.params.id) > 0)) {
        this.$router.push("/").catch(() => {});
      } else {
        this.getReport(this.$route.params.id, this.$route.params.reportId);
      }
    },
    // @vuese
    // Used to get report by id
    // @arg The argument is integer representing book id and report id
    getReport(bookId, id) {
      if (id > 0) {
        API.getReport(bookId, id)
          .then((response) => {
            this.currentReport = response.data;
            if (
              this.currentReport &&
              this.currentReport.reportDetails &&
              this.currentReport.reportDetails.length > 0
            ) {
              this.show = "review";
            } else {
              this.show = "period";
            }
          })
          .catch((error) => {
            console.log("Error " + error);
          });
      } else {
        this.currentReport = { id: -1 };
        this.show = "period";
      }
    },
  },
  created() {
    //this.currentReport = {id: -1}
    this.init();
  },

  computed: {
    ...mapGetters("currentuser", ["currentUser", "isApprentice", "isInstructor"]),
  },
};
</script>

<style lang="scss"></style>
